import httpRequest from '../../common/lib/http-request';

// *******************
// SUPPORT SERVICES
// *******************

function validateRegistrationSuspension(ballotRef) {
    return httpRequest({
        url: '/Suspension/validate/' + ballotRef,
        method: 'POST'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function validateRegistrationCloseSuspension(ballotRef) {
    return httpRequest({
        url: '/Suspension/close/validate/' + ballotRef,
        method: 'POST'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function submitRegistrationSuspension(request) {
    return httpRequest({
        url: '/Suspension/submit',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function submitCloseRegistrationSuspension(request) {
    return httpRequest({
        url: '/Suspension/close/submit',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const SuspensionService = { submitRegistrationSuspension, submitCloseRegistrationSuspension, validateRegistrationSuspension, validateRegistrationCloseSuspension }

export default SuspensionService;